import { showLoading } from "./helperFunctions";
import { searchQuery } from "./searchFunctions";
import { GEOSERVER_BASE_URL, GEOSERVER_WORKSPACE, DUMP_URL } from "./config/api.js";

var dumpUrl = DUMP_URL;

function formatPropertyName(name) {
  return name
    .replace(/ae/g, "ä").replace(/oe/g, "ö").replace(/ue/g, "ü")
    .replace(/Ae/g, "Ä").replace(/Oe/g, "Ö").replace(/Ue/g, "Ü")
    .replace(/^./, c => c.toUpperCase());
}

const htmlDeleteButtonHeader =
  "<button type='button' class='btn btn-danger btn-sm rounded-circle p-0 ms-1 deletePropertyButton' style='width:1.2rem;height:1.2rem;line-height:1;font-size:0.65rem;' title='Alle Werte dieser Eigenschaft entfernen'><i class='bi bi-x-lg'></i>";
const htmlDeleteButtonFooter = "</button>";

let allreadyInitialized = false;

/**  1.
 * Schaltet zur Experten Ansicht um
 */
export function switchToSearchFilter() {
  //Container ein bzw. ausblenden
  document.getElementById("SearchFilterContainer")?.classList.remove("d-none");
  document.getElementById("data-table")?.classList.add("d-none");

  //Prüfe ob die Expertensuche bereiuts initialisiert wurde
  if (!allreadyInitialized) {
    showLoading(true);
    getDBDump(dumpUrl);
    allreadyInitialized = true;
  }

  //Eventlistener für ClearSearch erstellen
  document.getElementById("resetTagSearchButton")?.addEventListener("click", function () {
    clearSearch();
  });
}

/** 2.
 * Ruft den gesamten Datenbankdump aller Bäume ab
 * @param {Die URL woher der Datenbank dump abgerufen wird} dumpUrl
 */
function getDBDump(dumpUrl) {
  let ignoreDumpUrl =
    `${GEOSERVER_BASE_URL}wfs?service=WFS&request=GetFeature&version=1.1.0&typeName=${GEOSERVER_WORKSPACE}:treesimport&outputFormat=application/json`;

  let resultObject = {};
  let resultObjectInitialized = false;

  //Daten Abrufen
  fetch(ignoreDumpUrl).then(r => r.json()).then(function (data) {
    //Iteriere über alle Bäume
    data.features.forEach(function (valueSet) {
      //Iteriere über jede eigenschaft jedes Baumes
      Object.entries(valueSet.properties).forEach(function ([description, singlePropertie]) {
        //Befülle einmalig Array Keys
        if (!resultObjectInitialized) {
          resultObject[description] = new Array();
        }
        //Wenn Wer vorhanden dann Werte Eintragen
        if (singlePropertie.length > 0) {
          resultObject[description].push(singlePropertie);
        }
      });
      // Setze Array Keys bereits befüllt
      resultObjectInitialized = true;
    });

    // Mehrfache Werte entfernen
    Object.entries(resultObject).forEach(function ([descriptor, allValues]) {
      resultObject[descriptor] = [...new Set(allValues)];
    });
    //Suchfilter in DIV Eintragen
    buildSearchFilters(resultObject);
  });
}

/**
 *  Diese Funktion fügt eigenschaften dem Suchstring hinzu
 * @param {Von welcher Eigenschaft aus der Link geklickt wurde} clickedLink
 */
function addToSearch(clickedLink) {
  var containerToAdd = document.getElementById(clickedLink.dataset.id);
  var clickedLinkID = clickedLink.dataset.id;
  var searchTag =
    "<span class='badge searchfilter-badge d-inline-flex align-items-center gap-1 removeTagFromSearch' id='" +
    clickedLinkID +
    "' data-value='" + clickedLink.textContent.trim().replace(/'/g, "\\'") + "'>" +
    clickedLink.textContent.trim() +
    "<span class='tag-remove-icon'><i class='bi bi-x'></i></span>" +
    "</span>";

  //Wenn bereits ein Container mit der Eigenschaftenbezeichnung besteht
  if (containerToAdd != null) {
    var nodeList = containerToAdd.childNodes;
    var setLink = true;
    //Pruefe ob der Wert bereit vorhanden ist
    Array.from(nodeList).forEach(function (val) {
      //Wenn ja, den Link nicht hinzufuegen
      if (val.innerText?.trim() == String(clickedLink.textContent.trim()))
        setLink = false;
    });
    //Wenn Nein den Link hinzufuegen
    if (setLink == true) {
      containerToAdd.innerHTML += searchTag;
    }
  }
  //Wenn der Container noch nicht vorhanden ist (Erster Wert der Eigenschaft der hinzugefuegt wird)
  else {
    var newNodeContainer = document.createElement("div");
    newNodeContainer.id = clickedLink.dataset.id;
    // newNodeContainer.class = "nodeContainer"; // add some css
    newNodeContainer.className = "search-tag-group d-flex align-items-center flex-wrap gap-1";
    newNodeContainer.innerHTML =
      "<span class='search-tag-group-label'>" +
      formatPropertyName(clickedLinkID.replace("-search", "")) +
      htmlDeleteButtonHeader +
      htmlDeleteButtonFooter +
      "</span>" +
      searchTag;

    document.getElementById("searchTags").appendChild(newNodeContainer); // add it to the parent div
  }

  //Eventlistener für Deletebuttons erstellen
  document.querySelectorAll(".deletePropertyButton").forEach(function (el) {
    el.addEventListener("click", function () { clearSearchPropertie(this); });
  });
  document.querySelectorAll(".removeTagFromSearch").forEach(function (el) {
    el.addEventListener("click", function () { removeFromSearch(this); });
  });
}

/**
 * Entfernt resetet die Suche
 * @param {Der Link von dem aus geklickt wurde} clickedLink
 */
function clearSearch() {
  document.getElementById("searchTags").innerHTML = "";
}

/**
 * Entfernt resetet die Suche
 * @param {Der Link von dem aus geklickt wurde} clickedLink
 */
function clearSearchPropertie(searchPropertyDIV) {
  searchPropertyDIV.parentElement.parentElement.remove();
}

/**
 * Entfernt die Eigenschaft
 * @param {Der Link von dem aus geklickt wurde} clickedLink
 */
function removeFromSearch(clickedLink) {
  let parentDiv = clickedLink.parentElement.closest("div");
  if (parentDiv.querySelectorAll(".searchfilter-badge").length <= 1) {
    parentDiv.remove();
  } else {
    clickedLink.remove();
  }
}

/**
 * Entfernt alle Eigenschaft
 * @param {Der Link von dem aus geklickt wurde} clickedLink
 */
function removeParentFromSearch(clickedLink) {
  clickedLink.parentNode.parentNode.remove();
}


function compareStrings(a, b) {
  // Assuming you want case-insensitive comparison
  a = a.toLowerCase();
  b = b.toLowerCase();

  return a < b ? -1 : a > b ? 1 : 0;
}

/**
 * Baut die Suchfilterfunktion anhand eines übergeben PHP-Json strings ab
 * @param {Übergebener Array von der PHP Abfrage} arrayWithValues
 */
const VISIBLE_LIMIT = 5;

function buildSearchFilters(arrayWithValues) {
  const sortable = Object.entries(arrayWithValues);
  let html = '<div class="row g-2">';

  sortable.forEach(function ([property, values], index) {
    const nonEmpty = values.filter(v => v !== "");
    if (nonEmpty.length === 0) return;

    const visible = nonEmpty.slice(0, VISIBLE_LIMIT);
    const hidden = nonEmpty.slice(VISIBLE_LIMIT);
    const collapseId = `sf-more-${index}`;

    const makeBadge = val =>
      `<span class="badge text-bg-primary cursor-hand searchfilter-badge me-1 mb-1" data-id="${property}-search">${val}</span>`;

    const visibleBadges = visible.map(makeBadge).join("");
    const hiddenBadges = hidden.map(makeBadge).join("");
    const moreButton = hidden.length > 0
      ? `<div>
           <button class="btn btn-link btn-sm p-0 mt-1 sf-toggle" data-collapse-target="${collapseId}">
             <span class="sf-show">+ ${hidden.length} weitere anzeigen</span>
             <span class="sf-hide">weniger anzeigen</span>
           </button>
           <div class="sf-collapse d-none" id="${collapseId}">${hiddenBadges}</div>
         </div>`
      : "";

    html += `
      <div class="col-12 col-md-6 col-xl-4">
        <div class="card h-100">
          <div class="card-body py-2 px-3">
            <div class="d-flex align-items-center mb-2">
              <strong class="me-2">${formatPropertyName(property)}</strong>
              <span class="badge text-bg-secondary">${nonEmpty.length}</span>
            </div>
            <div>${visibleBadges}</div>
            ${moreButton}
          </div>
        </div>
      </div>`;
  });

  html += "</div>";

  document.getElementById("SearchFilter").insertAdjacentHTML("beforeend", html);

  const container = document.getElementById("SearchFilter");
  container.querySelectorAll(".searchfilter-badge").forEach(function (el) {
    el.addEventListener("click", function () { addToSearch(this); });
  });

  container.querySelectorAll(".sf-toggle").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const target = document.getElementById(btn.dataset.collapseTarget);
      const isHidden = target.classList.contains("d-none");
      target.classList.toggle("d-none", !isHidden);
      btn.classList.toggle("open", isHidden);
    });
  });

  document.getElementById("searchTagButton")?.addEventListener("click", function () {
    clickFunction(this);
  });

  showLoading(false);
}

function showAlert(htmlErrorString) {
  if (htmlErrorString == null || htmlErrorString.length == 0) {
    htmlErrorString =
      "<strong>Genereller Fehler</strong> Bitte nehmen Sie Kontakt mit den Admins auf.";
  }
  const el = document.getElementById("alertWindow");
  el.innerHTML = htmlErrorString;
  el.classList.remove("d-none");
  el.style.opacity = "1";
  el.style.transition = "";
  setTimeout(() => {
    el.style.transition = "opacity 5s";
    el.style.opacity = "0";
  }, 2000);
  setTimeout(() => {
    el.classList.add("d-none");
    el.style.opacity = "";
    el.style.transition = "";
  }, 7000);
}

/**
 * Diese Funktion baut den SQL-Query String zusammen
 *
 *  Wenn Elemente da Sind für jedes Element (erstes element Überspringen)
 *  Spalte wählen und sem Suchstring hinzufügen
 *  danach für jede Eigenschaft (erstes element Überspringen) die Eigenschaft dem String hinzufügen
 *  Seperator nicht beim letzten Element einfügen
 */
function buildSearchString() {
  var containerType = "span";
  var concatMode = " OR ";
  var searchString = "";
  var htmlQuote = "'";
  var searchPropertyConcatMode = "WHERE";
  var space = " ";
  var equals = "=";
  var comma = ",";
  const searchTagsEl = document.getElementById("searchTags");
  var childElementCount = Number(searchTagsEl.childElementCount);

  document.getElementById("noSearchTagsSet")?.classList.add("d-none");

  // Wenn Elemente da Sind
  if (childElementCount > 0) {
    const groups = [];

    Array.from(searchTagsEl.childNodes).forEach(function (childNode) {
      const childNodeId = childNode.id.replace("-search", "");
      const tagBadges = Array.from(childNode.querySelectorAll(".searchfilter-badge"));
      if (tagBadges.length === 0) return;

      const parts = tagBadges.map(badge => {
        const value = badge.dataset.value ?? badge.innerText.trim();
        return childNodeId + equals + htmlQuote + value + htmlQuote;
      });

      groups.push(parts.length > 1 ? "(" + parts.join(concatMode) + ")" : parts[0]);
    });

    searchString = groups.join(" AND ");

    return {
      type: "treeclimatedb:treesimport",
      filter: searchString,
    };
  } else {
    showAlert(
      "<strong>Keine Suchfilter gewählt!</strong> Bitte wählen Sie mindestens einen Suchfilter aus."
    );

    return false;
  }
}

/**
 *
 * For encoding your url, just use one of the online tools. I just googles and found this one: url-encode-decode.com For instance,
 * the &CQL_FILTER=field=value AND field=value AND field=value becomes %26CQL_FILTER%3Dfield%3Dvalue+AND+field%3Dvalue+AND+field%3Dvalue.
 * @param {Typ zur Suche} type
 * @param {Angewendete Filter} filter
 */
function generateFilterUrl(type, filter) {
  //&CQL_FILTER=baumartdeutsch+LIKE+%27%25Eiche%25%27
  var urlPreString =
    `${GEOSERVER_BASE_URL}ows?service=WFS&version=1.0.0&request=GetFeature&typeName=`;
  var urlCQLFilter = "&CQL_FILTER=";
  var urlPostString = "&outputFormat=application/json";
  var url = "";
  var resultArray = [];

  url += urlPreString + type + urlCQLFilter + filter + urlPostString;

  return url;
}

function switchToSearchTerm() {
  getDBDump(dumpUrl);
}

function clickFunction() {
  var queryParameters = buildSearchString();

  if (queryParameters != false) {
    var url = generateFilterUrl(
      queryParameters["type"],
      queryParameters["filter"]
    );

    searchQuery(false, url);
    document.getElementById("SearchFilterContainer")?.classList.add("d-none");
    document.getElementById("data-table")?.classList.remove("d-none");
  }
}
